
import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";
import { Observable } from 'rxjs';
import { DeleteCompletePlanReques } from "../../domain/requests/plans/delete-complete-plan";

@Injectable({ providedIn: 'root' })
export class DeletePlanUsecase implements UseCase<DeleteCompletePlanReques, boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(params: DeleteCompletePlanReques): Observable<boolean> {
    return this.planRepository.deletePlan(params);
  }

}